var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAlphabetSortHover = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_811_52149)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.62734 16C4.29614 16 4.02734 15.7313 4.02734 15.4V0.6C4.02734 0.268799 4.29614 0 4.62734 0C4.95854 0 5.22734 0.268799 5.22734 0.6V15.4C5.22734 15.7313 4.95854 16 4.62734 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.62256 15.9999C4.4689 15.9999 4.31523 15.9415 4.19849 15.8238L1.39844 13.0239C1.16406 12.7894 1.16406 12.4094 1.39844 12.175C1.63296 11.9407 2.01294 11.9407 2.24731 12.175L4.62329 14.551L6.99927 12.175C7.23364 11.9407 7.61377 11.9407 7.84814 12.175C8.08252 12.4094 8.08252 12.7894 7.84814 13.0239L5.0481 15.8238C4.92974 15.9415 4.77607 15.9999 4.62256 15.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2248 15.9999H11.4247C11.2135 15.9999 11.0175 15.8887 10.9095 15.7078C10.8007 15.5263 10.7958 15.3015 10.8959 15.1159L13.2191 10.7999H11.4247C11.0935 10.7999 10.8247 10.5311 10.8247 10.1999C10.8247 9.86865 11.0935 9.59985 11.4247 9.59985H14.2248C14.4358 9.59985 14.6318 9.71104 14.7399 9.8918C14.8486 10.0734 14.8535 10.2983 14.7536 10.4839L12.4294 14.7999H14.2248C14.556 14.7999 14.8247 15.0687 14.8247 15.3999C14.8247 15.7311 14.556 15.9999 14.2248 15.9999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2243 6.40005C13.8931 6.40005 13.6243 6.13125 13.6243 5.80005V1.99995C13.6243 1.55845 13.2658 1.2 12.8242 1.2C12.3827 1.2 12.0242 1.55845 12.0242 1.99995V5.80005C12.0242 6.13125 11.7554 6.40005 11.4242 6.40005C11.093 6.40005 10.8242 6.13125 10.8242 5.80005V1.99995C10.8242 0.896777 11.721 0 12.8242 0C13.9273 0 14.8243 0.896777 14.8243 1.99995V5.80005C14.8243 6.13125 14.5555 6.40005 14.2243 6.40005Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2243 4.2H11.4242C11.093 4.2 10.8242 3.9312 10.8242 3.6C10.8242 3.2688 11.093 3 11.4242 3H14.2243C14.5555 3 14.8243 3.2688 14.8243 3.6C14.8243 3.9312 14.5555 4.2 14.2243 4.2Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_811_52149"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAlphabetSortHover, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/alphabet-sort-hover.2332365c.svg";
export { ForwardRef as ReactComponent };